const arrToObgIdKey = (arr) =>
  arr && arr.length ? arr.reduce((a, b) => ({ ...a, [b.id]: b }), {}) : {};
const activeSort = (arr) => {
  // От обычной сортировки отказался, т.к. он портит сортировку с бека (для разных типов фильтров по разному)
  const first = arr.filter((i) => i.active);
  const last = arr.filter((i) => !i.active);
  return [...first, ...last];
};

const getOneFilter = (allActive) => {
  const isPrice = allActive.filter((i) => i.filter === 'price').length > 0;
  const isBrands = allActive.filter((i) => i.filter === 'brand').length > 0;
  const isShops = allActive.filter((i) => i.filter === 'shop').length > 0;
  const isOtherFilters = Object.keys(
    arrToObgIdKey(allActive.filter((i) => i.filter === 'filter'))
  ).length;
  let result = 0;
  if (isPrice) result = result + 1;
  if (isBrands) result = result + 1;
  if (isShops) result = result + 1;
  if (isOtherFilters) result = result + isOtherFilters;
  return result;
};

export function mergeFilters(current, upd, ignore, allActive) {
  const ignoreBrands = ignore.filter((i) => i.filter === 'brand').length > 0;
  const activeBrands = allActive.filter((i) => i.filter === 'brand').length > 0;

  const ignoreShops = ignore.filter((i) => i.filter === 'shop').length > 0;
  const activeShops = allActive.filter((i) => i.filter === 'shop').length > 0;

  const ignoreOtherFilters = ignore.filter((i) => i.filter === 'filter');
  const filtersCount = getOneFilter(allActive);
  const result = { ...current };
  if ((ignoreBrands || activeBrands) && filtersCount < 2) {
    result.brands = current.brands;
  } else if (current.brands && upd && upd?.brands) {
    const updBrandsObj = arrToObgIdKey(upd?.brands);
    result.brands = activeSort(
      current.brands.map((brand) => {
        if (brand.id in updBrandsObj) {
          return { ...updBrandsObj[brand.id], active: true };
        } else {
          return { ...brand, active: false };
        }
      })
    );
  }

  if ((ignoreShops || activeShops) && filtersCount < 2) {
    result.shops = current?.shops;
  } else if (current?.shops && upd?.shops) {
    const updShopsObj = arrToObgIdKey(upd.shops);
    result.shops = activeSort(
      current.shops.map((shop) => {
        if (shop.id in updShopsObj) {
          return { ...updShopsObj[shop.id], active: true };
        } else {
          return { ...shop, active: false };
        }
      })
    );
  }

  if (current?.price && upd && upd?.price) {
    result.price = upd?.price;
  }
  const updFiltersObj = arrToObgIdKey(upd?.filters);
  result.filters = current.filters.map((f) => {
    if (f.type === 'BOOL') {
      return { ...f, active: f.id in updFiltersObj };
    } else if (f.type === 'RANGE') {
      if (f.id in updFiltersObj) {
        return { ...updFiltersObj[f.id], active: true };
      } else {
        return { ...f, active: false };
      }
    } else if (f?.allowed_values) {
      if (f.id in updFiltersObj && updFiltersObj[f.id].allowed_values) {
        const allowedValuesIds = f.allowed_values.map((i) => i.id);
        const oldFullAllowedValues = f.allowed_values;
        updFiltersObj[f.id].allowed_values.forEach((i, index) => {
          if (!allowedValuesIds.includes(i.id)) {
            oldFullAllowedValues.splice(index, 0, i);
          }
        });
        const ignoreOtherFiltersIds = ignoreOtherFilters.map((i) => i.id);
        const activeFiltersIds = allActive
          .filter((i) => i.filter === 'filter')
          .map((i) => i.id);
        const isOne =
          ignoreOtherFilters.length > 0 &&
          filtersCount < 2 &&
          activeFiltersIds.includes(f.id) &&
          ignoreOtherFiltersIds.includes(f.id);

        const activeItemsIds = updFiltersObj[f.id].allowed_values.map(
          (i) => i.id
        );
        const fullAllowedValues = oldFullAllowedValues.map((i) => ({
          ...i,
          active: isOne || activeItemsIds.includes(i.id),
        }));
        return {
          ...f,
          allowed_values: activeSort(fullAllowedValues),
        };
      } else {
        return {
          ...f,
          allowed_values: f?.allowed_values
            ? f?.allowed_values.map((i) => ({
                ...i,
                active: false,
              }))
            : f?.allowed_values,
        };
      }
    }
    return f;
  });
  return result;
}
